import { render } from "./PricingSetting.vue?vue&type=template&id=cb4497dc&ts=true"
import script from "./PricingSetting.vue?vue&type=script&lang=ts"
export * from "./PricingSetting.vue?vue&type=script&lang=ts"

import "./PricingSetting.vue?vue&type=style&index=0&id=cb4497dc&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/hems-frontend-vue_au_v1.33.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__